import React from "react";
import BatteryListTable from "../Components/BatteryListTable";
import { getRulCustomRenderers, getRulCSVFileName } from "./RULDetailsTableConfig";

const RULDetailsTable = ({ globalFilters = {}, additionalFilters = [] }) => (
  <BatteryListTable
    schemaPath="RULDetails"
    customRenderersFn={getRulCustomRenderers}
    getCSVFileName={getRulCSVFileName}
    defaultSortColumn="RULCalendarAgeDaysPredicted"
    globalFilters={globalFilters}
    additionalFilters={additionalFilters}
    pageSize={50}
  />
);

export default RULDetailsTable;
